export function Init(type) {
    const CNT = {
        Main:{
            Title:'AI智能外匯保證金程式交易API系統',
            Content1:'無需寫程式',
            Content2:'交給 AI！自動生成交易策略',
            Content3:'我們的API系統讓您可以輕鬆地無縫切換真實交易與歷史回測，並運用AI和大數據技術自動優化交易策略，幫助您降低交易風險、提升交易回報。',
            Content4:'強大的AI支持',
            Content5:'專業技術團隊',
            Content6:'24/7技術支持',
            Content7:'靈活部署與整合',
            Content8:'立即聯絡我們，獲取投資計畫書',
            Content9:'+886-931-353-154',
            Content10:'聯繫我們',
            Content11:'尋找產品投資夥伴',
            Content12:'共創 AI 交易未來',
            Content13:'/mas_web_demo_tw.mp4',
        },
        // Head:'ABOUT US'
    };

    const CNS = {
        Main:{
            Title:'AI智能外汇保证金程序交易API系统',
            Content1:'无需写程序',
            Content2:'交给 AI！自动生成交易策略',
            Content3:'我们的API系统让您可以轻松地无缝切换真实交易与历史回测，并运用AI和大数据技术自动优化交易策略，帮助您降低交易风险、提升交易回报。',
            Content4:'强大的AI支持',
            Content5:'专业技术团队',
            Content6:'24/7技术支持',
            Content7:'灵活部署与整合',
            Content8:'立即联系我们，获取投资计划书',
            Content9:'+886-931-353-154',
            Content10:'联系我们',
            Content11:'寻找产品投资伙伴',
            Content12:'共创 AI 交易未来',
            Content13:'/mas_web_demo_cn.mp4',
        },
        // Head:'关于我们'
    };

    const EN = {
        Main:{
            Title: "AI-Powered Forex Margin Trading API System",
            Content1: "No Coding Required",
            Content2: "Let AI Handle It! Automatically Generate Trading Strategies",
            Content3: "Our API system allows you to seamlessly switch between live trading and historical backtesting. With AI and big data technologies, we automatically optimize trading strategies to help you reduce risk and maximize returns.",
            Content4: "Advanced AI-Powered Trading",
            Content5: "Expert Technical Team",
            Content6: "24/7 Technical Support",
            Content7: "Flexible Deployment & Seamless Integration",
            Content8: "Contact us now to receive the investment prospectus",
            Content9: "+886-931-353-154",
            Content10: "Contact Us",
            Content11: "Seeking Strategic Investment Partners",
            Content12: "Co-Create the Future of AI Trading",
            Content13:'/mas_web_demo_en.mp4',
        },
        //Head:'ABOUT US'
    };

    const EN_GB = {
        Main:{
            Title: "AI-Powered FX Margin Trading API System",
            Content1: "No Coding Required",
            Content2: "Let AI Generate Trading Strategies for You",
            Content3: "Our API system lets you move seamlessly between live trading and historical back-testing. By combining AI with data analytics, it helps refine trading strategies, improve efficiency and strengthen risk management.",
            Content4: "AI-Powered Trading Support",
            Content5: "Experienced Technical Team",
            Content6: "24/7 Technical Support",
            Content7: "Flexible Deployment and Integration",
            Content8: "Contact us to request an investment proposal",
            Content9: "-552",
            Content10: "Contact Us",
            Content11: "Seeking Strategic Investment Partners",
            Content12: "Shaping the Future of AI Trading Together",
            Content13:'/MASQuant_web_demo_en.mp4',
        },
        //Head:'ABOUT US'
    };

    //return EN;
    if(type === 'zh-TW'){
        return CNT;
    } else if (type === 'zh-CN') {
        return CNS;
    } else if (type === 'en-GB') {
        return EN_GB;
    } else {
        return EN;
    }
}
